import styled, { css } from "styled-components";
import { gap, marginBottom } from "../../../styles";
import { Label as BaseLabel, Error, HelpText, RequiredStar } from "../common";
import React from "react";
import sanitize from "sanitize-html";
import { Checkbox as BaseInput } from "../../Checkbox/Checkbox";
import { SharedInputProps } from "../Input";
export type CheckboxProps = SharedInputProps & {
  // TODO: When we update to react>=18, remove this required prop and use the useId hook instead
  id: string;
};
export const CheckboxInputContainer = styled.div<{
  error: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  ${gap.s}

  ${({
  error
}) => !error && css`
      ${marginBottom.m}
    `}
`;
export const CheckboxInput = styled(BaseInput)<{
  error: boolean;
}>`
  ${({
  error
}) => error ? css`
          border-color: ${({
  theme
}) => theme.brand.cssVars["--d-error"]};
        ` : null}
`;
export const CheckboxLabel = styled(BaseLabel)`
  margin-top: 0.125rem;
`;
export const Container = styled.div`
  ${marginBottom.zero}
`;
export function Checkbox({
  label,
  helpText,
  error,
  ...props
}: CheckboxProps) {
  const {
    id,
    required
  } = props;
  const hasError = !!error;
  return <Container data-sentry-element="Container" data-sentry-component="Checkbox" data-sentry-source-file="Checkbox.tsx">
      <CheckboxInputContainer error={hasError} data-sentry-element="CheckboxInputContainer" data-sentry-source-file="Checkbox.tsx">
        <CheckboxInput error={hasError} aria-required={required} {...props} data-sentry-element="CheckboxInput" data-sentry-source-file="Checkbox.tsx" />
        <CheckboxLabel htmlFor={id} data-sentry-element="CheckboxLabel" data-sentry-source-file="Checkbox.tsx">
          {/* eslint-disable react/no-danger*/}
          <span dangerouslySetInnerHTML={{
          __html: sanitize(label?.toString() ?? "")
        }} />
          {/* eslint-enable react/no-danger*/}
          {required ? <RequiredStar /> : null}
        </CheckboxLabel>
      </CheckboxInputContainer>
      <HelpText data-sentry-element="HelpText" data-sentry-source-file="Checkbox.tsx">{helpText}</HelpText>
      {error ? <Error role="alert">{error}</Error> : null}
    </Container>;
}
export default Checkbox;